<template>
  <div class="FeedbackMessage" v-bind:class="cardClasses">
    <carousel
      :perPage="perPage"
      :navigationEnabled="navigationEnabled"
      :navigationNextLabel="navigationNextLabel"
      :navigationPrevLabel="navigationPrevLabel"
      :paginationEnabled="paginationEnabled"
      :paginationColor="paginationColor"
      :paginationActiveColor="paginationActiveColor"
      :autoplay="autoplay"
      :autoplayTimeout="autoplayTimeout"
      :autoplayHoverPause="autoplayHoverPause"      
      :loop="loop"
      :speed="speed"
      :easing="easing">
      <slide v-for="feedback in dataListMapped" :key="feedback.id">
        <div class="feedback-card">
          <img  class="feedback-card-image" :src="iconSrc">
          <div class="feedback-user">
            <img class="feedback-user-image" :src="feedback.imageSrc">
          </div>
          <p class="feedback-card-title">{{ feedback.title }}</p>
          <p class="feedback-card-message">{{ feedback.message }}</p>
          <hr>
          <div class="feedback-user">
            <div>
              <p class="feedback-user-name">{{ feedback.username }}</p>
              <p class="feedback-user-title">{{ feedback.role }}</p>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<style scoped>
.feedback-card {
  flex-shrink: 0;
  margin: 1rem;
  padding: 2rem;
  letter-spacing: 0px;
  text-align: center;
  box-shadow: 0px 5px 10px #00000026;
}

.feedback-card hr {
  width: 30%;
  margin: 2rem auto;
}

.feedback-card-image {
  margin-bottom: 1.5rem;
}

.feedback-card-title {
  text-align: center;
  font-size: 1.5rem;
  color: #444444;
}

.feedback-card-message {
  font-size: 1rem;
  color: #888888;
}

.feedback-user {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.feedback-user-image {
  float: left;
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 1rem;
  border-radius: 25px;
}

.feedback-user-name,
.feedback-user-title {
  letter-spacing: 0px;
  margin: 0;
}

.feedback-user-name {
  font-weight: bold;
  color: #666666;
}

.feedback-user-title {
  color: #888888;
}

.FeedbackMessage >>> .VueCarousel-dot,
.FeedbackMessage >>> .VueCarousel-dot-active,
.FeedbackMessage >>> .VueCarousel-dot-container {
  margin-top: 0 !important;
}

.FeedbackMessage >>> .VueCarousel-navigation {
  font-size: 2rem;
}

.FeedbackMessage__mobile >>> .VueCarousel-navigation .VueCarousel-navigation-next {
  transform: translateY(-50%) translateX(15%);
}

.FeedbackMessage__mobile >>> .VueCarousel-navigation .VueCarousel-navigation-prev {
  transform: translateY(-50%) translateX(-15%)
}
</style>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { randomString } from '../../util';

export default {
  props: {
    itemsPerPage: Number,
    device: String,
    dataList: Array,
    navigationEnabled: Boolean,
    paginationEnabled: Boolean,
    paginationColor: String,
    paginationActiveColor: String,
    autoplay: Boolean,
    autoplayTimeout: Number,
    autoplayHoverPause: Boolean,
    loop: Boolean,
    speed: Number,
    easing: String,
    iconSrc: String,
  },

  data: function() {
    return {
      navigationPrevLabel:
        `<i class="fas fa-arrow-circle-left" style="color: ${this.paginationColor};"></i>`,
      navigationNextLabel:
        `<i class="fas fa-arrow-circle-right" style="color: ${this.paginationColor};"></i>`,
    }
  },

  computed: {
    perPage: function() {
      return this.device !== 'mobile' ? this.itemsPerPage : 1
    },

    dataListMapped: function() {      
      return this.dataList.map(item => {
        item.id = item.id || randomString(15)

        return item
      })
    },

    cardClasses: function() {
      const cardClasses = []

      if (this.device === 'mobile')
        cardClasses.push('FeedbackMessage__mobile')

      return cardClasses
    },
  },

  components: {
    Carousel,
    Slide
  },
};
</script>